// Controller for stages-menu above the canvas
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []

  connect(){
    // Named this variable as serverController bcoz we have rails controllers(server side) and js controllers(client side)
    this.serverController = this.element.dataset.serverControllerName;
    this.itemId = this.element.dataset.itemId;
    this.typing = this.element.dataset.typing;
    this.itemType = this.element.dataset.itemType;
    this.stageSwitchSubmitBehavior = this.element.dataset.stageSwitchSubmitBehavior || '';
  }

  showNotes({ created_on_type_o_to_be_checked = false , created_on_type_o_misspelled = false, created_on_type_l_to_be_checked = false, created_on_type_l_misspelled = false }) {
    Rails.ajax({
      type: "GET",
      url: `/notes.js`,
      data: `item_id=${this.itemId}&item_type=${this.itemType}&item_controller=${this.serverController}&typing=${this.typing}&created_on_type_o_to_be_checked=${created_on_type_o_to_be_checked}&created_on_type_o_misspelled=${created_on_type_o_misspelled}&created_on_type_l_to_be_checked=${created_on_type_l_to_be_checked}&created_on_type_l_misspelled=${created_on_type_l_misspelled}`
    });
  }

  submitValues(event) {
    switch (this.stageSwitchSubmitBehavior) {
    case 'typing':
      typing_form?.submitForStageSwitch(event);
      break;
    case 'cropper':
      // Cropper #initializeSaveListenersOnPageChange on .cropper-stages .nav-pills owns preventDefault, submit, and navigation.
      break;
    default:
      this.defaultStageSwitchSubmitBehavior(event);
    }
  }

  // Callers without data-stage-switch-submit-behavior, to keep the old behavior as default
  defaultStageSwitchSubmitBehavior(event) {
    const formSubmitButton = document.querySelector('[data-typing-form-target="formSubmitButton"]') ||
                             document.querySelector('[data-cropper-target="formSubmitButton"]');

    if (formSubmitButton) {
      formSubmitButton.click();
      cropper?.setUnsavedChanges(false);
    }
  }
}

$(document).ready(function() {
  $('.js-submit-message-modal').on('shown.bs.modal', function () {
    // Focus on the textarea inside the modal
    $('.js-submit-message-textarea', this).focus();
  });
});
